import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

import seemaImg from "../../Assests/seema.jpeg";
import ashokImg from "../../Assests/ashok.jpeg";
import raoImg from "../../Assests/rao.jpeg";


const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: "Dr Seema Handu",
      position: "Country Director, Pronto International",
      content: "Lumbini Consultancy has been instrumental in helping us in assessment of LaQshya and strategy to achieve certification.. Their expertise and dedication made the entire process smooth and efficient.",
      rating: 5,
      image: seemaImg
    },
    {
      id: 2,
      name: "Mr. Ashok Sharma",
      position: "Managing Director- Sai Eye Hospital ",
      content: "The HR solutions provided by Lumbini are exceptional. They helped us build a strong team and streamline our recruitment process significantly.",
      rating: 5,
      image: ashokImg
    },
    {
      id: 3,
      name: "Vunnava Janardhan Rao",
      position: "PME Manager, Heifer International",
      content: "Their research and documentation services are top-notch. The quality of reports and analysis exceeded our expectations.",
      rating: 5,
      image: raoImg
    }
  ];

  return (
    <section className="py-20 sm:py-24 bg-gradient-to-br from-gray-50 via-white to-blue-50/30 relative overflow-hidden">
      {/* Enhanced background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(37,99,235,0.03),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(8,145,178,0.02),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[linear-gradient(135deg,transparent_0%,rgba(37,99,235,0.01)_50%,transparent_100%)]"></div>

      {/* Enhanced decorative elements */}
      <div className="absolute top-16 left-16 w-48 h-48 bg-gradient-to-br from-lumbini-blue/4 to-transparent rounded-full opacity-50"></div>
      <div className="absolute bottom-16 right-16 w-40 h-40 bg-gradient-to-br from-lumbini-cyan/5 to-transparent rounded-full opacity-40"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-br from-accent-400/6 to-transparent rounded-full opacity-35"></div>
      <div className="absolute top-1/3 right-1/3 w-16 h-16 bg-gradient-to-br from-lumbini-blue/3 to-transparent rounded-full opacity-30"></div>
      
      <div className="container-custom px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 text-gray-900">
            What Our <span className="text-lumbini-blue">Clients Say</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Don't just take our word for it. Here's what our satisfied clients have to say about our services.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="group relative"
            >
              {/* Clean professional testimonial card */}
              <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative h-full flex flex-col">
                
                {/* User info section - Top */}
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover mr-4 border-2 border-gray-200"
                  />
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-gray-900 mb-1">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.position}</p>
                  </div>
                </div>

                {/* Rating stars - Second */}
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400 space-x-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-current" />
                    ))}
                  </div>
                  <span className="ml-2 text-sm text-gray-500">{testimonial.rating}/5</span>
                </div>

                {/* Quote - Third */}
                <div className="flex-1">
                  <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                    "{testimonial.content}"
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;

